import React from "react";
import T from "Translate";
import Customer from "Services/http/customer";
import trim from "lodash/trim";
import Cookies from "universal-cookie";

export const fieldIsActive =
    fieldName =>
    ({ form }) => {
        const field = form && form.getFieldState(fieldName);
        return !!(field && (field.touched || field.dirty));
    };

export const fieldIsValid =
    fieldName =>
    ({ form }) => {
        const field = form && form.getFieldState(fieldName);
        return !!(field && field.valid);
    };

export const verifyDistId = async value => {
    const cookies = new Cookies();
    cookies.set("refEnrollerName", "", { path: "/" });
    if (trim(value)) {
        cookies.remove("refEnrollerError", { path: "/" });
        cookies.remove("refEnrollerName", { path: "/" });
        let sponsorError = false;
        await Customer.getDistributorDetails(trim(value))
            .then(response => {
                let item = response.data.data
                if (item.error) {
                    sponsorError = true;
                    cookies.set("refEnrollerError", "Error", { path: "/" });
                    return;
                } 
                
                item = item.items[0];
                if (
                    item.status !== "Active" &&
                    item.status !== "Pending"
                ) {
                    sponsorError = true;
                    cookies.set("refEnrollerError", "Error", { path: "/" });
                } else {
                    const { firstName, lastName, fullName } = item.humanName;
                    let { companyName } = item.businessEntity || "";
                    if (companyName) {
                        cookies.set("refEnrollerName", companyName, { path: "/" });
                    } else if (fullName) {
                        cookies.set("refEnrollerName", fullName, { path: "/" });
                    } else {
                        cookies.set("refEnrollerName", firstName + " " + lastName, { path: "/" });
                    }
                }
            })
            .catch(error => {
                sponsorError = true;
            });
        if (sponsorError) {
            return <T>{"error_valid_id"}</T>;
        }
    }
    return undefined;
};

export const validateSponsor = (...args) =>
    new Promise(resolve => {
        if (this.clearTimeout) this.clearTimeout();
        const timerId = setTimeout(() => {
            return resolve(verifyDistId(...args));
        }, 500);
        this.clearTimeout = () => {
            clearTimeout(timerId);
            resolve();
        };
    });



// WEBPACK FOOTER //
// ./src/components/Common/Validation/ValidSponsor.js